<template>
  <div class="card mb-4">
    <TableInfoBar
      :total="totalItems"
      v-model:pageSize="pageSize"
      :page-sizes="pageSizes"
      create-label="스캔장소 등록"
      v-model:query="q"
      :searchPlaceholder="'장소명/URN 검색'"
      @search="onSearch"
      @create="createData"
    />

    <div class="card-body px-4 pt-0 pb-2">
      <BaseDataTable
        :loading="loading"
        :items="readPointList"
        :columns="columns"
        :total="totalItems"
        v-model:page="page"
        v-model:pageSize="pageSize"
        :page-sizes="pageSizes"
        :colgroup="colgroup"
        :rowKey="rowKey"
        empty-message="등록된 스캔장소가 없습니다."
        @row-click="onRowClick"
      >
        <template #row="{ item, index }">
          <td class="text-center text-sm">{{ totalItems - rowStartIndex - index }}</td>
          <td class="text-center text-sm">{{ item.name }}</td>
          <td class="text-center text-sm">
            <!-- <soft-badge color="info" variant="gradient" size="sm">{{ item.urn }}</soft-badge> -->
            <CustomBadge level="very-high" size="sm" :label="item.urn" />
          </td>
          <td class="text-center text-sm">{{ formatDate(item.createdAt) }}</td>
          <td class="text-center text-sm">{{ item.updatedAt ? formatDate(item.updatedAt) : '-' }}</td>
        </template>
      </BaseDataTable>
    </div>
  </div>

  <ReadPointTour />
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import TableInfoBar from '@/components/pagination/TableInfoBar.vue';
import SoftBadge from "@/components/SoftBadge.vue";
import SoftButton from "@/components/SoftButton.vue";
import ReadPointTour from "@/components/tour/ReadPointTour.vue";
import api from '@/api/api';

export default {
  name: "read-point-table",
  components: { 
    SoftButton,
    SoftBadge,
    BaseDataTable,
    TableInfoBar,
    CustomBadge,
    ReadPointTour,
  },
  data() {
    return {
      loading: false,
      readPointList: [],

      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50],
      totalItems: 0, 
      sort: 'createdAt',

      columns: [
        { label: 'No.' },
        { label: '장소명' },
        { label: 'urn' },
        { label: '생성일시' },
        { label: '수정일시' },
      ],
      colgroup: [
        'width:10%',
        'width:25%',
        'width:25%',
        'width:20%',
        'width:20%',
      ],
      q: "",
    };
  },
  computed: {
    rowStartIndex() {
      return (this.page - 1) * this.pageSize;
    },
  },
  watch: {
    page() {
      this.fetchData();
    },
    pageSize() {
      this.fetchData();
    },
  },
  mounted() { 
    const { page, size, q, sort } = this.$route.query;
    this.updatingFromRoute = true;  
    if (page) this.page = +page;
    if (size) this.pageSize = +size;
    if (q !== undefined) this.q = q;
    if (sort) this.sort = sort;
    this.updatingFromRoute = false;
    this.fetchData(); 
  },
  methods: {
    rowKey(item, idx) { return item.id ?? idx; },
    async fetchData() {
      if(this.loading) return;

      this.loading = true;
      try {
        const mfId = this.$store.getters['UserStore/getMfId'];
        const [res] = await Promise.all([
          api.get('/readPoint/page', {
            params: { mfId, page: this.page, size: this.pageSize, sort: this.sort, query: this.q  }
          }),
          new Promise(r => setTimeout(r, 600))
        ]);

        const r = res.data?.result || {};
        this.readPointList = r.items || [];
        this.totalItems = Number(r.total || 0);

        const pageCount = Math.max(1, Math.ceil(this.totalItems / this.pageSize));
        if (this.page > pageCount) this.page = pageCount;
      } catch (error) {
        console.error("스캔장소 정보 불러오기 실패:", error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.page = 1;
      this.fetchData();
    },
    onRowClick(item, index){
      this.$router.push({
        name: "ReadPointEdit",
        params: { id: item.id },
        query: {
          page: this.page,
          size: this.pageSize,
          q: this.q,
          sort: this.sort,
        },
      });
    },
    createData(){
      this.$router.push({
        name: "ReadPointCreate",
      });
    }
  }
};
</script>
